// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import t from 'tcomb';

const OpenMaintenancePlan = t.struct({
    machineTypes: t.list(KeyValuePair),
    pin: t.String,
    planDescription: t.String,
    planName: t.String,
    showAdditionalComments: t.Bool,
    showMachineType: t.Bool,
    showNoTravel: t.Bool
}, {
    name: 'OpenMaintenancePlan',
    strict: true
});

export const getDefaultState = () => new OpenMaintenancePlan({
    machineTypes: [getKeyValuePairDefaultState()],
    pin: '',
    planDescription: '',
    planName: '',
    showAdditionalComments: false,
    showMachineType: false,
    showNoTravel: false
});

export default OpenMaintenancePlan;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/open-maintenance-plan.js